import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";
import {
  CREATE_DOCUMENT_SUCCESS,
  FETCH_DOCUMENT_SUCCESS,
  GET_DOCUMENT_SUCCESS,
  SAVE_DOCUMENT_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import React from 'react';
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message, notification, Typography} from "antd";

const {Title} = Typography;

export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_DOCUMENT_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_DOCUMENT_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_DOCUMENT_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_DOCUMENT_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {document} = store.getState();
      const {query} = document;
      const response = await axios.get(`/document?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response && response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      await Object.keys(payload).forEach(key => {
        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/document`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/document');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    // console.log(payload);
    try {
      let formData = new FormData();
      await Object.keys(payload).forEach(key => {
        if(key === 'renewalDate' || key === 'documentDate') {
          if(payload[key]) {
            return formData.append(key, payload[key]);
          }
          return;
        }
        if(key === 'existingDocuments' || key === 'docTypeObject' || key === 'file') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }
        formData.append(key, payload[key]);
      });
      const response = await axios.put(`/document/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      if(payload && payload.asset) {
        if(response.data && response.data.length) {
          response.data.map((msg, key) => {
            notification.error({
              key,
              duration: 30,
              message: `Dpcument Upload Error from server!`,
              description: <>
                <Title
                  level={4}>{`Document ${msg.documentName} is overlapped with ${msg.overlappedDocumentName}`}</Title>
                <a target='_blank'
                   href={`/document/edit/${msg.overlappedDocumentId}`}>{`Edit ${msg.overlappedDocumentName}`}</a>
              </>,
            })
          });
        }
        history.push('/asset/upload/' + payload.asset);
      } else {
        history.goBack();
        //history.push('/document');
        dispatch(getResource());
      }
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/document/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id, flag = false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/document/${id}`);
      history.goBack();
      dispatch(fetchSuccess());
      if(!flag) {
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const docUrl = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/document/${id}`);
      dispatch(fetchSuccess());
      if(response && response.data && response.data.file.path)
        window.open(response.data.file.path);
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
